import type { Types as Skola24Types } from '../types';
import type { OutTypes } from './schedule';

export default function (
  rooms:    Skola24Types.room[],
  warnings: string[],
  errors:   string[]
): OutTypes.location[] {
  return rooms.map(x => ({
    ids:         x.PK.toString(),
    displayName: x.ID
  }));
}
